import styled from 'styled-components'
import { breakpoints } from '../../../../constants'

export const StyledForm = styled.form`
	.fields {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			display: grid;
			grid-template: repeat(3, auto) / repeat(4, 1fr);
			grid-column-gap: 3rem;
		}
	}

	.input-container:first-child {
		grid-area: 1 / 1 / 2 / 7;
	}

	.input-container:last-child {
		grid-area: 3 / 1 / 4 / 7;
	}

	.button {
		margin-left: auto;
	}
`

export const StyledPointsBlock = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	@media (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
	}

	.async-select-field {
		max-width: 700px;
	}

	.points {
		text-align: right;
		margin-top: 3rem;
		margin-left: 3rem;
		font-size: 16px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			margin-top: unset;
		}
	}

	.saldo {
		white-space: nowrap;
	}

	.value {
		font-size: 3.6rem;
	}
`
